import { Component } from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'
import Money from './Money'

const Box = styled.div`
  display: flex;
  align-items: baseline;
  line-height: 1.25;
  @media (max-width: 768px) {
    flex-wrap: wrap;

    & + & {
      margin-top: 10px;
    }
  }
`

const Label = styled.div`
  text-align: right;
  flex: 0 1 260px;
  min-width: 0;
  padding: 2px 20px;
  color: ${p => p.theme.cardFieldLabelColor};
  font-size: 1rem;
  @media (max-width: 768px) {
    flex: 0 0 100%;
    text-align: left;
    padding: 2px 0;
  }
`

const Value = styled.div`
  flex: ${p => (p.subValue ? '0 1 200px' : '1 1 200px')};
  min-width: 0;
  overflow-wrap: break-word;
  padding: 0 20px;
  color: ${p =>
    p.type === 'header' ? p.theme.cardFieldLabelColor : p.theme.cardFieldValueOtherColor};
  font-size: 1rem;

  @media (max-width: 768px) {
    flex: 0 0 100%;
    padding: 0 0 2px;
  }
`

const SubValue = styled.div`
  /* Size the parenthetical to its content so it doesn't wrap unnecessarily. */
  flex: 0 0 auto;
  padding: 0 20px;
  color: ${p => p.theme.cardFieldLabelColor ?? '#7a8e96'};
  font-size: ${p => (p.subValueSmall ? '0.875rem' : '1rem')};
  white-space: ${p => (p.type === 'header' ? 'nowrap' : '')};
  @media (max-width: 768px) {
    flex: 0 0 100%;
    padding: 0 0 2px;
  }
`

class CardField extends Component {
  static propTypes = {
    isCurrency: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subValue: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.element]),
  }

  render() {
    const { isCurrency, label, subValue, value, type, subValueSmall = true } = this.props
    const val = isCurrency ? <Money value={value} /> : <span>{value}</span>
    return (
      <Box className={this.props.className}>
        <Label type={type}>{label}</Label>
        <Value type={type} subValue={subValue}>
          {val}
        </Value>
        {subValue && (
          <SubValue type={type} subValueSmall={subValueSmall}>
            {subValue}
          </SubValue>
        )}
      </Box>
    )
  }
}

export const CardFieldError = styled.div`
  color: #eb436c;
  padding: 1.5rem 3rem;
  line-height: 1.35;
  text-align: center;
`

export default CardField
